<template>

  <v-container fluid class="page page-home pt-4">

    <!--------------------->
    <!-- Welcome Message -->
    <!--------------------->
    <v-row class="mb-5" v-if="showWelcomeMessage">
      <v-col class="d-flex align-center justify-center welcome-message">
        {{ welcomeMessageText }}
      </v-col>
    </v-row>

    <!---------------------------->
    <!-- User Awaiting Approval -->
    <!---------------------------->
    <v-row class="d-flex align-center justify-center" v-if="isAwaitingAccountApproval">
      <v-alert prominent type="info">
        <div class="awaiting-approval-message">
          <div>Thanks for signing up with RouteLeaf!</div>
          <div>Your account is being reviewed.</div>
        </div>
      </v-alert>
    </v-row>

    <!------------------------------>
    <!-- Shipper Account Features -->
    <!------------------------------>
    <template v-else-if="uiType === 'shipper'">
      <!-- User Setup Guide -->
      <v-row align="center" justify="center">
        <v-col cols="12" xs="12" sm="12" md="10" lg="9">
          <user-app-setup-guide
              :showOrgSetup="$root.activeUserHasRole('admin')"
              :showDriverSetup="false"
              @loaded="loadAccountSetupStatus" />
        </v-col>
      </v-row>

      <!-- Shipper Info Dashboard -->
      <v-row align="center" justify="center" class="mt-0" v-if="enableShipperDashboard && isAccountSetup">
        <v-col cols="12" xs="12" sm="12" md="10" lg="9">
          <org-dashboard-stats-shipper-ui />
        </v-col>
      </v-row>
    </template>

    <!------------------------------->
    <!-- SysAdmin Account Features -->
    <!------------------------------->
    <template v-else-if="uiType === 'sys-admin'">
      <!-- Customer Info Dashboard -->
      <v-row align="center" justify="center">
        <v-col cols="12" xs="12" sm="12" md="10" lg="9">
          <org-dashboard-stats-sys-admin-ui />
        </v-col>
      </v-row>
    </template>

  </v-container>

</template>

<script>
import UserAppSetupGuide from '@/components/users/UserAppSetupGuide'
import OrgDashboardStatsShipperUi from '@/components/orgs/OrgDashboardStatsShipperUi'
import OrgDashboardStatsSysAdminUi from '@/components/orgs/OrgDashboardStatsSysAdminUi'

export default {
  name: 'HomePage',

  components: {
    UserAppSetupGuide,
    OrgDashboardStatsShipperUi,
    OrgDashboardStatsSysAdminUi
  },

  data () {
    return {
      enableShipperDashboard: false,
      accountSetupStatus: null
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    activeUser () {
      return this.$store.getters['auth/activeUser']
    },
    isAuthenticatedSession () {
      return this.$store.getters['auth/isAuthenticated']
    },
    activeUserRoles () {
      return this.activeUser.roles
    },
    showWelcomeMessage () {
      return this.uiType === 'shipper' || this.uiType === 'receiver'
    },
    welcomeMessageText () {
      return `Welcome, ${this.activeUser.display_name}!`
    },
    isAwaitingAccountApproval () {
      return this.isAuthenticatedSession && this.activeUserRoles && this.activeUserRoles.length === 0
    },
    isAccountSetup () {
      return (this.accountSetupStatus && this.accountSetupStatus.org_setup === true)
    }
  },

  methods: {
    goToUserSettingsPage () {
      this.$root.goTo('user-settings-profile')
    },

    // Load account setup status
    loadAccountSetupStatus (info) {
      this.accountSetupStatus = info
    }
  }
}
</script>

<style scoped>
  .welcome-message {
    margin-top: 24px;
    font-size: 20px;
  }

  .awaiting-approval-message {
    padding: 10px 30px;
  }
</style>
